import { Navigate } from "react-router-dom";
import { VISOR_MODULE_BREADCRUMB_ROOT } from "@/modules/workModuleCore";
import { useAuth } from "@/lib/auth";
import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import { useWorkspaceMode } from "@/lib/workspaceMode";
import { PageHeader } from "./layoutChrome";
import GestionUsuariosEquipo from "@/components/GestionUsuariosEquipo";
import CommercialClassificationNotice from "@/components/commercial/CommercialClassificationNotice";

export default function UsuariosDistribuidor() {
  const { user } = useAuth();
  const { mode, canSwitch } = useWorkspaceMode();
  const isPlatformDesigner = usePlatformDesigner();

  const isAdminLike = Boolean(user?.is_admin_owner || user?.role === "admin");
  const canUse = Boolean(user?.can_generate_licenses);
  const wrongMode = Boolean(canSwitch && mode !== "distribuidor");

  if (!isAdminLike || !canUse) {
    const fallback = isPlatformDesigner || canUse ? "/disenador/inicio" : "/";
    return <Navigate to={fallback} replace />;
  }

  if (wrongMode && !isPlatformDesigner) {
    return (
      <>
        <PageHeader
          title="Usuarios Administradores BNT"
          subtitle="Equipo interno del proveedor BNT: diseñador, administrador, soporte, comercial y auditoría. Usuarios internos de BNT o del distribuidor. No usar para dar de alta auxiliares del comprador/despacho."
          breadcrumb={[VISOR_MODULE_BREADCRUMB_ROOT, "Usuarios Administradores BNT"]}
        />
        <div className="p-8 max-w-2xl">
          <div className="rounded-sm border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950">
            Cambia a <strong>Distribuidor</strong> en la barra lateral para gestionar usuarios del equipo comercial.
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <PageHeader
        title="Usuarios Administradores BNT"
        subtitle="Equipo interno del proveedor BNT: diseñador, administrador, soporte, comercial y auditoría. Usuarios internos de BNT o del distribuidor. No usar para dar de alta auxiliares del comprador/despacho."
        breadcrumb={[VISOR_MODULE_BREADCRUMB_ROOT, "Usuarios Administradores BNT"]}
      />
      <div className="p-8 max-w-5xl space-y-4">
        <div
          className="rounded-sm border border-[#0F2D5C]/15 bg-[#0F2D5C]/[0.04] px-4 py-3 text-xs text-slate-700"
          data-testid="usuarios-distribuidor-bnt-only-notice"
        >
          <strong>Usuarios internos de BNT o del distribuidor.</strong> No usar para dar de alta auxiliares del
          comprador/despacho. Los usuarios auxiliares del comprador se administran en{" "}
          <strong>Panel General → Actividades de Equipo</strong> (<code>/?panel=equipo</code>
          ).
        </div>
        <CommercialClassificationNotice variant="distributor_users" />
        <GestionUsuariosEquipo variant="distribuidor" showResellerUi />
      </div>
    </>
  );
}
